import { useLocation, Link as ReactRouterLink } from 'react-router-dom';
import { css } from '@emotion/core';
import Link from '@veeva/corgix/link';
import useMessageService from '../../services/i18n/useMessageService';
import { UnauthenticatedPaths, AuthenticatedPaths } from '../../constants/Paths';
import FooterLanguageSelect from './FooterLanguageSelect';

const LegalFooterMobile = () => {
    const [
        [
            privacyPolicyLabel = 'Privacy Policy',
            copyrightLabel = 'Copyright 2010-{0} Veeva',
            learnMoreLabel = 'Learn More',
        ],
    ] = useMessageService([
        'legal_footer.privacy_policy',
        'legal_footer.copyright',
        'general.learn_more',
    ]);
    const { pathname } = useLocation();

    return (
        <div
            css={css`
                font-size: 1rem;
                display: flex;
                flex-direction: column;
                width: 100%;
                align-items: center;
                gap: 0.666rem;
            `}
        >
            <div
                css={css`
                    text-align: center;
                `}
            >
                <Link
                    href="https://www.veeva.com/veeva-id/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {privacyPolicyLabel}
                </Link>
                {pathname !== AuthenticatedPaths.VAULT_INVITES && (
                    <>
                        <span
                            css={css`
                                margin-right: 0.3333rem;
                                margin-left: 1rem;
                            `}
                        >
                            |
                        </span>
                        <FooterLanguageSelect placement="topRight" />
                    </>
                )}
            </div>
            <div>
                <span
                    css={css`
                        color: #303030;
                    `}
                >
                    {copyrightLabel?.replace('{0}', new Date().getFullYear().toString())}
                </span>
                <span
                    css={css`
                        margin: 0 0.3333rem;
                    `}
                >
                    |
                </span>
                <ReactRouterLink
                    css={({ blue }) => {
                        return css`
                            font-size: 1rem;
                            color: ${blue};
                            text-decoration: none;
                        `;
                    }}
                    to={UnauthenticatedPaths.LEARN_MORE}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {learnMoreLabel}
                </ReactRouterLink>
            </div>
        </div>
    );
};

export default LegalFooterMobile;
